import { render, staticRenderFns } from "./FollowCard.vue?vue&type=template&id=d78c3710&scoped=true"
import script from "./FollowCard.vue?vue&type=script&lang=js"
export * from "./FollowCard.vue?vue&type=script&lang=js"
import style0 from "./FollowCard.vue?vue&type=style&index=0&id=d78c3710&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d78c3710",
  null
  
)

export default component.exports